import BucketDeals from "../../features/bucket-deals/BucketDeals";

export default function BucketDealsPage() {
  return (
    <div>
      <BucketDeals></BucketDeals>
    </div>
  );
}
